"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TableRow_1 = require("./TableRow");
const { root, hover, selected } = TableRow_1.tableRowClasses;
const MuiTableRowOverrides = {
    MuiTableRow: {
        styleOverrides: {
            root: ({ theme }) => ({
                [`&.${root}.${selected}`]: {
                    backgroundColor: theme.palette.blue[100],
                },
                [`&.${root}.${hover}:not(.${selected}):hover`]: {
                    backgroundColor: theme.palette.gray[100],
                    cursor: 'pointer',
                },
            }),
        },
    },
};
exports.default = MuiTableRowOverrides;
//# sourceMappingURL=MuiTableRowOverrides.js.map